import { IProduct } from "@/src/types/product";
import type { Product as ApiProduct } from "@/src/types/tenant";


export function isOfferActive(start?: string, end?: string): boolean {
  if (!start || !end) return false;
  const now = Date.now();
  return now >= new Date(start).getTime() && now <= new Date(end).getTime();
}

function getCurrentPrice(p: ApiProduct) {
  return p.pricing?.offerPrice ?? p.pricing?.sellingPrice ?? 0;
}

export function mapProduct(p: ApiProduct, fallbackOutletId: string): IProduct {
  const price = getCurrentPrice(p);
  const mrp = p.pricing?.mrp ?? 0;
  const originalPrice =
    mrp > price ? mrp
      : p.pricing?.sellingPrice && p.pricing.sellingPrice > price
        ? p.pricing.sellingPrice
        : undefined;
  const discountPct =
    originalPrice && originalPrice > 0
      ? Math.round(((originalPrice - price) / originalPrice) * 100)
      : undefined;

  return {
    id: p._id,
    name: p.name,
    price,
    originalPrice,
    discountPct,
    image: p.images?.thumbnail || "",
    /* The card's OWN branch, never the page's. A grouped catalogue can mix
     * branches, and the cart files each line against this id — checkout splits
     * shipments by it. Mirrors `outletIdOf` in groupCatalog: nested outlet
     * first, then the flat field, and only then the page's fallback. */
    outletId: p.outlet?.outletId || p.outletId || fallbackOutletId,
    outletCity: p.outlet?.city ?? undefined,
    outletName: p.outlet?.outletName ?? undefined,
    tenantId: p.tenantId,
    isOffer: !!p.pricing?.offerPrice,
    category: p.category?.name,
    // Taxonomy ids, kept so the storefront can honour the tenant's
    // `productPriority` order (which department opens first). The display label
    // above is not enough — priority is configured by id.
    categoryId: p.category?._id != null ? String(p.category._id) : undefined,
    subcategoryIds: (p.subcategories ?? []).map((sc) => String(sc._id)),
    stock: p.inventory?.quantity,
    offerStartTime: p.pricing?.offerStartTime,
    offerEndTime: p.pricing?.offerEndTime,
    variantCount: p.variantCount,
    variants: p.variants?.map((v) => ({
      variantId: v.variantId,
      sku: v.sku,
      label: v.label,
      thumbnail: v.thumbnail,
      sellingPrice: v.sellingPrice,
      mrp: v.mrp,
      stockQuantity: v.stockQuantity,
    })),
  };
}